import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import { useMediaQueryContext } from 'contexts/MediaQueryContext'
import { media } from 'styles/media'

import { SubSection } from '../listing/Sections/shared'
import RiparideLogoIcon from '../../components/icons/RiparideSmallLogo'

import { Subtitle } from './Sections/shared'

const Content = styled.div`
  ${Subtitle} {
    margin-bottom: 20px;
  }

  ${SubSection} {
    text-align: left;
    max-width: 650px;
    margin: 0;
    font-size: 18px;
    line-height: 1.8;
  }
`

const LinkWrapper = styled.div`
  a {
    font-weight: 500;
    color: ${({ theme }) => theme.brand.jungle};
  }
`

const Inner = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;

  ${media.md`
    flex-direction: row;
  `}

  svg {
    color: ${({ theme }) => theme.brand.jungle};
    flex-shrink: 0;
    width: 64px;
    margin-bottom: 30px;

    ${media.md`
      width: 120px;
      margin: auto;
      margin-right: 60px;
    `}
  }
`

const Outer = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.brand.sand};
  padding: 30px;
  border-radius: 6px;
  margin-bottom: 162px;

  ${media.md`
    padding: 60px;
  `}
`

export default () => {
  const { md: largerThanMd } = useMediaQueryContext()
  const smallerThanMd = !largerThanMd

  const [t] = useTranslation('spelling')

  return (
    <Outer>
      <Inner>
        {smallerThanMd && <RiparideLogoIcon />}
        <Content>
          <Subtitle>What are Riparide Stories?</Subtitle>
          <SubSection>
            <p>
              Riparide Stories are authentic experiences shared by real{' '}
              {t('traveler')}s (who are handy with a camera). It&apos;s like
              reading your best friend&apos;s travel journal - packed with
              photos, honest reviews and visual itineraries.
            </p>
            <LinkWrapper>
              <a href="/stories-travellers">Learn More</a>
            </LinkWrapper>
          </SubSection>
        </Content>
        {!smallerThanMd && <RiparideLogoIcon />}
      </Inner>
    </Outer>
  )
}
